import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { Platform, View, Pressable, Image, useWindowDimensions, ScrollView } from 'react-native';
import { useAppSelector, useAppDispatch } from '../../hooks/store-hook';
import useCustomTheme from '../../hooks/theme-hook';
import useTranslation from '../../hooks/translation-hook';
import { lightBoxActions } from '../../store/lightBoxSlice';
import CustomButton from '../common/CustomButton';
import Label from '../common/Label';

export interface LoginPopupProps {
  onLogin?(): void;
  onSignUp?(): void;
}

const LoginPopup = (props: LoginPopupProps) => {
  const theme = useCustomTheme();
  const layout = useWindowDimensions();
  const authStore = useAppSelector((selector) => selector.auth);
  const dispatch = useAppDispatch();
  const t = useTranslation();
  const isDesktop = layout.width > 1200;
  const isNativeMobile = Platform.OS !== 'web' && !isDesktop;
  const popupWidth = isDesktop ? 570 : 350;
  const mobileHeroHeight = 270;
  const mobilePopupMaxHeight = Math.min(layout.height - 24, 560);

  return (
    <ScrollView
      style={{
        backgroundColor: theme.background.primary,
        width: popupWidth,
        flexShrink: 1,
        maxHeight: isNativeMobile ? mobilePopupMaxHeight : undefined,
      }}
      contentContainerStyle={{ flexGrow: 0 }}
      bounces={false}
      alwaysBounceVertical={false}
      alwaysBounceHorizontal={false}
      overScrollMode="never"
    >
      {isDesktop ? (
        <Image style={{ position: 'absolute', top: -1, right: -1, width: 275, height: 300 }} source={require('../../../assets/loginLady.png')} />
      ) : (
        <View style={{ height: mobileHeroHeight, overflow: 'hidden' }}>
          <Image style={{ position: 'absolute', top: -26, right: 0, width: 350, height: 338 }} source={require('../../../assets/loginLady-m.png')} />
        </View>
      )}
      <Pressable
        hitSlop={8}
        style={{ position: 'absolute', top: isDesktop ? 8 : 10, right: 10, zIndex: 2000, padding: 6 }}
        onPress={() => {
          dispatch(lightBoxActions.setVisibility(false));
        }}
      >
        <FontAwesomeIcon color={theme.isDark ? theme.text.primary?.toString() ?? '#ffffff' : 'white'} icon={faXmark} size={24} />
      </Pressable>
      <View style={{ padding: isDesktop ? 16 : 20, paddingTop: isDesktop ? 16 : 8, paddingBottom: isDesktop ? 16 : 20 }}>
        <Label
          numberOfLines={4}
          style={
            isDesktop
              ? { width: 240, fontSize: 40, color: theme.text.darkTurquoiseTwo, fontWeight: '700' }
              : { width: 'auto', textAlign: 'center', fontSize: 30, color: theme.text.darkTurquoiseTwo, fontWeight: '700' }
          }
        >
          {t('Log-in-or-sign-up')}
        </Label>
        <Label
          numberOfLines={3}
          style={isDesktop ? { width: 300, marginTop: 24, fontSize: 16 } : { width: 'auto', textAlign: 'center', marginTop: 16, fontSize: 16 }}
        >
          {t('Use-your-email-or-another-service-to-continue-with')}
        </Label>
        <View style={{ flexDirection: isDesktop ? 'row' : 'column', gap: 16, marginTop: isDesktop ? 24 : 16 }}>
          <CustomButton
            style={{ minWidth: 150 }}
            title={t('login_title')}
            onPress={() => {
              props.onLogin && props.onLogin();
            }}
          />
          <CustomButton
            style={{ minWidth: 150 }}
            secondary
            title={t('login.sign_up')}
            onPress={() => {
              props.onSignUp && props.onSignUp();
            }}
          />
        </View>
      </View>
    </ScrollView>
  );
};

export default LoginPopup;
